// Source: https://play.tailwindcss.com/hDXu45UJ0P

const OPTION = {
  ".ds-option input": {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px",
  },
  ".ds-option": { "@apply ds-select-none": true },
  ".ds-option input:disabled ~ div": {
    "@apply ds-border-tertiary-lightgrey ds-bg-background-grey ds-text-tertiary-mediumgrey": true,
  },
  ".ds-option.ds-invalid input:not(:disabled) ~ div": {
    "@apply ds-border-secondary-red-70": true,
  },
  ".ds-option.ds-invalid:hover input:not(:disabled) ~ div,\n.ds-option.ds-invalid:focus input:not(:disabled) ~ div,\n.ds-option.ds-invalid:focus-within input:not(:disabled) ~ div":
    {
      "@apply ds-border-secondary-red": true,
    },
  ".ds-option.ds-invalid input:checked ~ div": {
    "@apply ds-ring-inset ds-ring-1 !ds-ring-secondary-red !ds-border-secondary-red ds-bg-background-red": true,
  },
  ".ds-option.ds-valid input:not(:disabled) ~ div": {
    "@apply ds-border-secondary-green-70": true,
  },
  ".ds-option.ds-valid:hover input:not(:disabled) ~ div,\n.ds-option.ds-valid:focus input:not(:disabled) ~ div,\n.ds-option.ds-valid:focus-within input:not(:disabled) ~ div":
    {
      "@apply ds-border-secondary-green": true,
    },
  ".ds-option.ds-valid input:checked ~ div": {
    "@apply ds-ring-inset ds-ring-1 !ds-ring-secondary-green !ds-border-secondary-green ds-bg-background-green": true,
  },
  ".ds-option input:not(:disabled) ~ div": { "@apply ds-cursor-pointer": true },
  ".ds-option input:checked ~ div::before": {
    content: '"\\e97f"',
    fontFamily: '"Vattenfall Elements Icons", "Vattenfall Icons"',
    "@apply ds-float-right": true,
    "@apply ds-float-right ds-w-xl ds-text-xl ds-text-right": true,
  },
  ".ds-option input:not(:checked) ~ div::before": {
    content: '""',
    "@apply ds-float-right ds-w-xl ds-text-xl": true,
  },
  ".ds-check-round input:checked ~ div::before": {
    "@apply ds-bg-primary-white ds-text-center ds-rounded-full ds-border-2 ds-border-solid ds-border-primary-blue ds-min-w-[34px]": true,
  },
  ".ds-check-group input:checked ~ div::before": {
    "@apply ds-absolute ds-right-sm ds-min-w-[34px]": true,
  },
  "label.ds-option.ds-option-col div": {
    "@apply ds-inline-flex ds-flex-col ds-text-center ds-w-xl before:!ds-absolute before:!ds-self-end": true,
  },
  "label.ds-option div": {
    "@apply ds-inline-block ds-min-w-full md:ds-min-w ds-font-regular ds-text-xl ds-px-lg ds-py-[10px] ds-border ds-rounded-md ds-border-tertiary-lightgrey": true,
  },
  "label.ds-option.ds-fluid div": { "@apply ds-block ds-min-w-full": true },
  "label.ds-option.ds-small div": {
    "@apply ds-text-base ds-leading-[30px]": true,
  },
  "label.ds-option input:checked ~ div": {
    "@apply ds-ring-inset ds-ring-1 !ds-ring-primary-blue !ds-border-primary-blue ds-bg-background-blue": true,
  },
  "label.ds-option:hover input:checked:not(:disabled) ~ div,\nlabel.ds-option:focus input:checked:not(:disabled) ~ div,\nlabel.ds-option:focus-within input:checked:not(:disabled) ~ div":
    {
      "@apply ds-ring-2": true,
    },
  "label.ds-option:hover input:not(:disabled) ~ div,\nlabel.ds-option:focus input:not(:disabled) ~ div,\nlabel.ds-option:focus-within input:not(:disabled) ~ div":
    {
      "@apply ds-border-tertiary-mediumgrey ds-outline-none": true,
    },
  "fieldset.ds-option": {
    "@apply ds-inline-grid ds-min-w-full md:ds-min-w ds-divide-y ds-divide-tertiary-lightergrey ds-outline-none": true,
  },
  "fieldset.ds-option.ds-fluid": { "@apply ds-grid ds-min-w-full": true },
  "fieldset.ds-option label": { "@apply ds-min-w-full ds-outline-none": true },
  "fieldset.ds-option div": {
    "@apply ds-font-regular ds-text-xl ds-block ds-px-lg ds-py-[10px] ds-border-tertiary-lightgrey ds-bg-primary-white": true,
  },
  "fieldset.ds-option.ds-small div": {
    "@apply ds-text-base ds-leading-[30px]": true,
  },
  "fieldset.ds-option label div": { "@apply ds-border-x": true },
  "fieldset.ds-option label:first-child div": {
    "@apply ds-border-t ds-rounded-t-md": true,
  },
  "fieldset.ds-option label:last-child div": {
    "@apply ds-border-b ds-rounded-b-md": true,
  },
  "fieldset:not(:disabled).ds-option label div:hover,\nfieldset:not(:disabled).ds-option label input:checked ~ div,\nfieldset:not(:disabled).ds-option label:focus div,\nfieldset:not(:disabled).ds-option label:focus-within div":
    {
      "@apply ds-border -ds-my-px ds-relative ds-z-10": true,
    },
  "fieldset:not(:disabled).ds-option label:first-child input:checked ~ div,\nfieldset:not(:disabled).ds-option label:first-child div:hover,\nfieldset:not(:disabled).ds-option label:first-child:focus div,\nfieldset:not(:disabled).ds-option label:first-child:focus-within div":
    {
      "@apply ds-mt-0": true,
    },
  "fieldset:not(:disabled).ds-option label:last-child input:checked ~ div,\nfieldset:not(:disabled).ds-option label:last-child div:hover,\nfieldset:not(:disabled).ds-option label:last-child:focus div,\nfieldset:not(:disabled).ds-option label:last-child:focus-within div":
    {
      "@apply ds-mb-0": true,
    },
  "fieldset:not(:disabled).ds-option label div:hover,\nfieldset:not(:disabled).ds-option label:focus-within div,\nfieldset:not(:disabled).ds-option label:focus div":
    {
      "@apply ds-border-tertiary-mediumgrey": true,
    },
  "fieldset.ds-option label input:checked ~ div": {
    "@apply !ds-border-primary-blue ds-ring-1 ds-ring-inset ds-ring-primary-blue ds-bg-background-blue ds-z-20": true,
  },
  "fieldset.ds-option label:focus input:checked:not(:disabled) ~ div,\nfieldset.ds-option label input:checked:focus:not(:disabled) ~ div":
    {
      "@apply ds-ring-2": true,
    },
  "fieldset:not(:disabled).ds-option label:hover ~ label div,\nfieldset:not(:disabled).ds-option\n  label:focus\n  ~ label\n  div\n  fieldset:not(:disabled).ds-option\n  label:focus-within\n  ~ label\n  div":
    {
      borderColor: "rgb(185, 185, 185)",
    },
  "fieldset:not(:disabled).ds-option.ds-invalid label:hover ~ label div,\nfieldset:not(:disabled).ds-option.ds-invalid label:focus ~ label div,\nfieldset:not(:disabled).ds-option.ds-invalid label:focus-within ~ label div":
    {
      borderColor: "#f93b1890",
    },
  "fieldset:not(:disabled).ds-option.ds-valid label:hover ~ label div,\nfieldset:not(:disabled).ds-option.ds-valid label:focus ~ label div,\nfieldset:not(:disabled).ds-option.ds-valid label:focus-within ~ label div":
    {
      borderColor: "#3dc07c90",
    },
  "@media (min-width: 599px)": {
    "fieldset.ds-option.ds-row": {
      "@apply ds-grid-flow-col ds-divide-x ds-divide-y-0": true,
    },
    "fieldset.ds-option.ds-row label div": {
      "@apply ds-border-y ds-border-x-0 ds-h-full": true,
    },
    "fieldset.ds-option.ds-row label:first-child div": {
      "@apply ds-border-l ds-rounded-l-md ds-rounded-r-none": true,
    },
    "fieldset.ds-option.ds-row label:last-child div": {
      "@apply ds-border-r ds-rounded-r-md ds-rounded-l-none": true,
    },
    "fieldset:not(:disabled).ds-option.ds-row label input:checked ~ div,\n  fieldset:not(:disabled).ds-option.ds-row label div:hover,\n  fieldset:not(:disabled).ds-option.ds-row label:focus div,\n  fieldset:not(:disabled).ds-option.ds-row label:focus-within div":
      {
        "@apply -ds-mx-px ds-my-0 ds-border-x": true,
      },
    "fieldset:not(:disabled).ds-option.ds-row label:first-child input:checked ~ div,\n  fieldset:not(:disabled).ds-option.ds-row label:first-child div:hover,\n  fieldset:not(:disabled).ds-option.ds-row label:first-child:focus div,\n  fieldset:not(:disabled).ds-option.ds-row label:first-child:focus-within div":
      {
        "@apply ds-ml-0 ds-mt-0 ds-border-r": true,
      },
    "fieldset:not(:disabled).ds-option.ds-row label:last-child input:checked ~ div,\n  fieldset:not(:disabled).ds-option.ds-row label:last-child div:hover,\n  fieldset:not(:disabled).ds-option.ds-row label:last-child:focus div,\n  fieldset:not(:disabled).ds-option.ds-row label:last-child:focus-within div":
      {
        "@apply ds-mr-0 ds-mb-0 ds-border-l": true,
      },
  },
};

// TODO (stefan): Make this global
// When exporting a Tailwind CSS to JavaScript using this tool: https://transform.tools/css-to-js
// we also need to remove the prefix (ds) before we can use it inside our config.
// This utility function solves that problem.
// We might consider turning this into a global utility if we want to use it in more components
// in the future.
const parseKeys = (source) => {
  const target = {};
  for (const sourceKey in source)
    if (typeof source[sourceKey] === "object") {
      const targetKey = sourceKey.replace(/\.ds-/g, ".").replace(/\n/, "");
      target[targetKey] = parseKeys(source[sourceKey]);
    } else target[sourceKey] = source[sourceKey];
  return target;
};

module.exports = () => parseKeys(OPTION);
